module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Weather/Snow-b061feaec9545ec8ab6edd83abc80924.svg";